export const COMPLIANCE_CHECKER_ERRORS = {
  Result: {
    FIRST_ROW_NOT_CATEGORY:
      'La première ligne de données doit être une ligne de catégorie.',
    SUBCATEGORY_WITHOUT_VALUE:
      'Une ligne avec un champ **sous-catégorie** défini doit aussi avoir un champ **valeur** défini.',
    CATEGORY_WITHOUT_SUBCATEGORY:
      'Une ligne avec un champ **catégorie** défini doit aussi avoir un champ **sous-catégorie** défini.',
    CATEGORY_ROW_MISSING_FIELDS:
      'Une ligne de catégorie doit inclure une sous-catégorie et une valeur.',
    VALUE_MISSING: 'Toutes les lignes doivent avoir une **valeur** définie.',
    INCOMPLETE_VALUE: 'Valeur incomplète',
    INVALID_HIERARCHY: '**Hiérarchie** doit être une valeur numérique (n ≥ 0).',
  },

  Scenario: {
    MISSING_NAME_OR_DEFAULT:
      'Chaque ligne doit avoir un champ **nom** et un champ **valeur par défaut** définis.',
    INVALID_OPTIONS_FORMAT:
      'Si le champ **options** est défini, il doit contenir au moins deux valeurs séparées par des virgules.',
    DEFAULT_NOT_IN_OPTIONS:
      'La **valeur par défaut** doit faire partie des **options** spécifiées.',
    FIRST_ROW_MISSING_CATEGORY:
      'La première ligne doit avoir une propriété **catégorie** définie.',
    TIME_HORIZON_ROW_MISSING:
      'Il doit toujours avoir exactement une ligne avec le nom "Horizon" dans cette feuille.',
  },

  CarePathway: {
    FIRST_ROW_NOT_STEP:
      "La première ligne de données doit être une ligne d'étape.",
    INCOMPLETE_STEP: 'Étape incomplète.',
    INCOMPLETE_IMPACT_CATEGORY: "Catégorie d'impact incomplète",
    INCOMPLETE_IMPACT: 'impact incomplet',
    INCOMPLETE_SUBIMPACT_1: 'Sous-valeur 1 incomplète',
    INCOMPLETE_SUBIMPACT_2: 'Sous-valeur 2 incomplète',
    STEP_AMOUNT_OUT_OF_RANGE:
      'Il doit y avoir au total entre 3 et 6 étapes dans le parcours de soins.',
  },

  KeyValueSheets: {
    // Intro & Config
    MISSING_KEY_OR_VALUE:
      'Toutes les lignes de cette feuille doivent contenir une **clé** et une **valeur**',
  },

  Config: {
    INVALID_THEME:
      'La valeur fournie pour la case **thème** est invalide. Veuillez utiliser une des options de la liste déroulante.',
    MISSING_THEME: 'La clé **theme** et/ou sa valeur sont manquantes.',
  },

  Summary: {
    INVALID_ITEM: 'Toutes les valeurs du bloc ne sont pas définies',
    INVALID_IMAGE:
      'On ne peut pas définir une image et des informations en même temps',
  },

  SHEET_MISSING_OR_EMPTY: "La feuille n'existe pas ou est vide",
};
